import { useQuery } from "@tanstack/react-query";
import { API } from "config";

export default function useDistributors(page, filters) {
    return useQuery({
        queryKey: ["distributors", page, filters],
        queryFn: async () => {
            const response = await API.get("/store/distributors", {
                params: {
                    page,
                    name: filters.name || undefined,
                    city: filters.city || undefined,
                    state: filters.state || undefined, // ← novo campo
                    financial: filters.financial || undefined, // novo campo
                },
            });
            return response.data;
        },
    });
}
